import { Box } from "@mui/material";
import { isToday } from "date-fns";

import { useFiltersContext } from "components/contexts";
import { Widget, WidgetContent } from "components/elements/mui";
import { useFormatMessage } from "lang";
import { getLiveData, getSelectedPowerPlant, useAppSelector } from "store";
import { stalePulseSx } from "styles/animations";
import { formatEnergy } from "utils/energy";

export const EnergyInfoToday = ({
  icon,
  url,
  size,
}: {
  icon?: string;
  url?: string;
  size?: { xs?: number; sm?: number; md?: number };
}) => {
  const formatMessage = useFormatMessage();
  const liveData = useAppSelector(getLiveData);
  const selectedPowerPlant = useAppSelector(getSelectedPowerPlant);
  const { energyType: energyTypeContext } = useFiltersContext();
  const energyType = energyTypeContext[0];

  if (!liveData) return null;

  // Meter-only fields are absent on inverter-sourced snapshots; render an
  // em-dash rather than crashing or pretending it's zero.
  const liveValue = liveData[energyType];
  const energy = formatEnergy(liveValue?.day ?? 0);
  const offline = selectedPowerPlant?.offline;
  const dataFromToday = liveData?.date ? isToday(liveData.date) : false;
  const showValue = (!offline || dataFromToday) && liveValue !== undefined;

  const content = (
    <WidgetContent
      value={showValue ? energy.value : "—"}
      unit={showValue ? energy.unit : ""}
    />
  );

  return (
    <Widget
      title={`${formatMessage(energyType)} (${formatMessage("today")})`}
      icon={icon}
      content={
        offline && dataFromToday ? (
          <Box sx={stalePulseSx()}>{content}</Box>
        ) : (
          content
        )
      }
      url={url}
      size={size}
    />
  );
};
